<template>
    <div class="container-fluid mt-3">
        <div class="card">
            <div class="card-body">
                <h4 class="p-2">Vincular docente a campo formativo</h4>
                <form autocomplete="off" @submit.prevent="getCampoFormativoDocente()">
                    <vs-row class="mt-4">
                        <vs-col sm="12" lg="3">
                            <vs-select :loading="loadingInstitucion" filter label="Institución" placeholder="Seleccionar institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length">
                                <template #message-danger v-if="errorFields.includes('institucion')">
                                    Requerido
                                </template>
                                <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </vs-select>
                        </vs-col>
                        <vs-col sm="12" lg="3">
                            <vs-select :loading="loadingPrograma" filter label="Programa" placeholder="Seleccionar programa" :key="programaId" v-model="programa" :disabled="!programas.length">
                                <template #message-danger v-if="errorFields.includes('programa')">
                                    Requerido
                                </template>
                                <vs-option v-for="option in programas" :key="option.id"  :label="option.text" :value="option.id">
                                    {{option.text}}
                                </vs-option>
                            </vs-select>
                        </vs-col>
                        <vs-col  sm="12" lg="3" style="margin-top: 5px;">
                            <vs-button
                            >
                                <i class="fas fa-search mr-2"></i>Buscar
                            </vs-button>
                        </vs-col>
                    </vs-row>
                </form>
            </div>
        </div>
        <tabla-campo-formativo-docente class="mt-3" :users="users"></tabla-campo-formativo-docente>
    </div>
</template>
<script>
import academico from '../../../../api/requests/academico.js'
import tablaCampoFormativoDocente from './tabla_campo_formativo_docente.vue'
export default {
    data() {
        return {
            institucion: '',
            instituciones: [],
            institucionId: (new Date()).getTime(),
            loadingInstitucion: false,
            programa: '',
            programas: [],
            programaId: (new Date()).getTime(),
            loadingPrograma: false,
            errorFields: [],
            users: [
                {
                    persona_id: 5486,
                    apellido_paterno: "ARAUZ",
                    apellido_materno: "PAREDES",
                    nombres: "LEONARDO",
                    programa: "Educación Basica Primaria",
                    matricula: "RPLE5485",
                    campo_formativo_id: 1,
                },
                {
                    persona_id: 5479,
                    apellido_paterno: "ARREDONDO ",
                    apellido_materno: "MUÑIZ",
                    nombres: "URIEL",
                    programa: "Educación Basica Primaria",
                    matricula: "RMUR5478",
                    campo_formativo_id: 2,
                },
                {
                    persona_id: 74328,
                    apellido_paterno: "Balderas",
                    apellido_materno: "Grimaldo",
                    nombres: "Gloria Mariana",
                    programa: "Educación Basica Primaria",
                    matricula: "BGNI74327",
                    campo_formativo_id: '',
                },
                {
                    persona_id: 65258,
                    apellido_paterno: "Balderas",
                    apellido_materno: "Torres",
                    nombres: "Guadalupe del Carmen",
                    programa: "Educación Basica Primaria",
                    matricula: "BTGU65255",
                    campo_formativo_id: 4,
                }
            ]
        }
    },
    components:{
        tablaCampoFormativoDocente
    },
    created(){
        this.getInstituciones()
    },
    methods:{
        async getInstituciones(){
            try {
                this.loadingInstitucion = true
                const response = await academico.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstitucion = false
            }
            catch{

            }
        },
        async getPrograma(){
            if (this.institucion) {
                try {
                    this.loadingPrograma = true
                    const {data: response} = await academico.getPrograma(this.institucion)
                    this.programas = response
                    this.programaId = (new Date()).getTime()
                    this.loadingPrograma = false
                } catch (error) {
                    
                }
            }
        },
        async getCampoFormativoDocente(){
            try{
                const {data: response } = await academico.getCampoFormativoDocente()
            }catch(error){

            }
        }
    }
}
</script>